<template>
  <router-view class="person-referrals-leads"></router-view>
</template>

<script>
import _ from 'lodash'
import { leadsRoute } from '../../referralsRoute'

export default {
  components: {

  },
  data () {
    return {
      activeBtnName: null
    }
  },
  computed: {
    headBtnList () {
      const vm = this
      return _.map(leadsRoute.children, item => {
        return {
          route: item,
          labelI18nKey: item.meta.menuI18nKey,
          get isActive () { return vm.activeBtnName === this.route.name },
          onclick: this.handleHeadBtnClick
        }
      })
    }
  },
  created () {
    this.$emit('setHeadBtn', this.headBtnList)
    this.refreshActiveBtnName()
  },
  beforeDestroy () {
    this.$emit('setHeadBtn', [])
  },
  methods: {
    refreshActiveBtnName (currentRoute) {
      currentRoute = currentRoute || this.$route
      let foundName = null
      const routeName = currentRoute.name
      _.forEach(this.headBtnList, (btnItem) => {
        const route = btnItem.route
        const btnItemName = route.name
        if (btnItemName === routeName) {
          foundName = btnItemName
        } else if (route.children) {
          const childMenu = _.find(route.children, { name: routeName })
          if (childMenu) {
            foundName = btnItemName
          }
        }
        return !foundName
      })
      if (foundName) {
        this.activeBtnName = foundName
      } else {
        const parentRoute = currentRoute.meta?._parent
        if (parentRoute) {
          this.refreshActiveBtnName(parentRoute)
        }
      }
    },
    handleHeadBtnClick ($event, btnInfo) {
      const route = btnInfo.route
      this.$router.push({ path: route.path, query: this.$route.query })
      this.activeBtnName = route.name
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
